<template>
  <q-card class="my-card bg-amber-2">
    <q-card-section>
      <div v-if="!$apollo.loading">
        <div class="text-h4  text-center">SANTANDER</div>
        <div class="text-h6  text-center">Débito</div>
        <br>
        <apexchart type=bar height=220 :options="options" :series="series"/><!--
        <apexchart type=bar height=200 :options="options2" :series="series2"/>-->
        <!--<q-select outlined class="col-md-12" :options="optionsSelect" label="Selecione um período" v-model="periodSelected" @change="update">
      </q-select>-->
      </div>

      <q-inner-loading :showing="$apollo.loading">
        <q-spinner-dots size="50px" color="primary"/>
      </q-inner-loading>
    </q-card-section>

    <!--            <q-card-actions> -->
    <!--              <q-btn flat>Action 1</q-btn>-->
    <!--              <q-btn flat>Action 2</q-btn>-->
    <!--            </q-card-actions>-->
  </q-card>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'
import { DEBIT_SANTANDER_CHART } from '../graphql/graphql'
import { numberToReal } from '../helpers'

export default {
  name: 'Santander',
  components: {
    apexchart: VueApexCharts
  },
  data () {
    return {
      periodSelected: null,
      optionsSelect: ['02/2020', '01/2020', '12/2019', '11/2019', '10/2019', '09/2019'],
      debitSantanderCharts: [],
      series: [],
      series2: [],
      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'],
      options: {

        colors: ['#FF4560', '#00E396', '#775DD0'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '55%',
            columnWidth: '70%',
            barHeight: '70%'
          }
        },
        stroke: {
          width: 5,
          colors: ['transparent']
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#000']
          },
          formatter: function (val, opt) {
            return numberToReal(val)
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        xaxis: {
          categories: ['A receber', 'Pago', 'Total de doações'],
          labels: {
            style: {
              colors: this.colors,
              fontSize: '14px'
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return numberToReal(val)
            }
          }
        },
        theme: {
          mode: 'light',
          palette: 'palette4'

        }
      },
      options2: {

        colors: ['#FF4560', '#00E396', '#775DD0'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '55%',
            columnWidth: '70%',
            barHeight: '70%'
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#000']
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        stroke: {
          width: 5,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['Doadores pagantes', 'Doadores não pagantes'],
          labels: {
            style: {
              colors: this.colors,
              fontSize: '14px'
            }
          }
        },
        theme: {
          mode: 'light',
          palette: 'palette4'
        }
      }
    }
  },
  apollo: {
    debitSantanderCharts: {
      query: DEBIT_SANTANDER_CHART,
      update (store, data) {
        this.series = []
        this.series2 = []
        this.series.push({ name: 'A receber', data: [store.debitSantanderCharts[0]] })
        this.series.push({ name: 'Pago', data: [store.debitSantanderCharts[1]] })
        this.series.push({ name: 'Total', data: [store.debitSantanderCharts[2]] })

        this.series2.push({ name: 'Doadores não pagantes', data: [store.debitSantanderCharts[3]] })
        this.series2.push({ name: 'Doadores pagantes', data: [store.debitSantanderCharts[4]] })
        this.series2.push({ name: 'Total doadores', data: [store.debitSantanderCharts[5]] })
      }
    }
  },
  props: {
    init: {
      type: String,
      required: true
    },
    finit: {
      type: String,
      required: true
    },
    change: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  watch: {
    change (newVal, oldVal) {
      if (newVal) {
        this.update()
      }
    }
  },
  methods: {
    update () {
      this.$apollo.queries.debitSantanderCharts.skip = false
      this.$apollo.queries.debitSantanderCharts.setVariables({ init: this.init, finit: this.finit })
      this.$apollo.queries.debitSantanderCharts.refetch().then(result => {
        this.donator = result.data.donator
      })
    },
    updateOld () {
      this.$apollo.queries.debitSantanderCharts.skip = false
      this.$apollo.queries.debitSantanderCharts.setVariables({ })
      this.$apollo.queries.debitSantanderCharts.refetch().then(result => {
        this.donator = result.data.donator
      })
    }
  }
}
</script>

<style scoped>

</style>
